(() => {
  const insuranceSelector = '.mw-fee--type-cart input.mw-fee__control--type-checkbox';
  const preferenceFallback = new Map();

  const preferenceKey = (input) => {
    const feeId = input.closest('.mw-fee')?.dataset.feeId || input.name;
    return `techs-choice-package-insurance-${feeId}`;
  };

  const getPreference = (key) => {
    if (preferenceFallback.has(key)) return preferenceFallback.get(key);

    try {
      return window.sessionStorage.getItem(key);
    } catch (_) {
      return null;
    }
  };

  const setPreference = (key, value) => {
    preferenceFallback.set(key, value);

    try {
      window.sessionStorage.setItem(key, value);
    } catch (_) {
      // The in-memory preference still prevents re-enabling during this page view.
    }
  };

  const isPackageInsurance = (input) => {
    const fee = input.closest('.mw-fee');
    const title = fee?.querySelector('[data-fee-header]')?.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    return title === 'package insurance';
  };

  const enableByDefault = (input) => {
    if (input.dataset.packageInsuranceDefaultBound === 'true' || !isPackageInsurance(input)) return;

    input.dataset.packageInsuranceDefaultBound = 'true';
    const key = preferenceKey(input);

    input.addEventListener('change', (event) => {
      if (!event.isTrusted) return;
      setPreference(key, input.checked ? 'accepted' : 'declined');
    });

    if (input.checked || input.disabled || getPreference(key) === 'declined') return;

    requestAnimationFrame(() => {
      if (document.contains(input) && !input.checked && getPreference(key) !== 'declined') {
        input.click();
      }
    });
  };

  const scan = (root = document) => {
    if (root.matches?.(insuranceSelector)) enableByDefault(root);
    root.querySelectorAll?.(insuranceSelector).forEach(enableByDefault);
  };

  scan();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
